import { render } from "./GTSelect.vue?vue&type=template&id=fa6a4d9c&scoped=true"
import script from "./GTSelect.vue?vue&type=script&lang=js"
export * from "./GTSelect.vue?vue&type=script&lang=js"

import "./GTSelect.vue?vue&type=style&index=0&id=fa6a4d9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fa6a4d9c"

export default script